import React, { useId } from 'react';

function Toggle({ checked, onChange, label, disabled = false, className = '' }) {
  const id = useId();
  return (
    <label htmlFor={id} className={`sgc-toggle ${disabled ? 'sgc-toggle--disabled' : ''} ${className}`}>
      {label && <span className="sgc-toggle__label">{label}</span>}
      <span className="sgc-toggle__track">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange?.(e.target.checked)}
          className="sgc-toggle__input"
        />
        <span className="sgc-toggle__thumb" />
      </span>
    </label>
  );
}

export default Toggle;
